import {
  IUserLogin,
  IUserLoginResponse,
  IUserRefreshResponse,
  IUserRefreshBody,
  IForgotPasswordResponse,
  IForgotPasswordDetails,
  IResetPasswordResponse,
  IResetPasswordDetails,
  IVerifyTokenResponse,
  IVerifyTokenDetails,
} from './../../models/user';
import { authHttp, http } from '../common/http.service';
import { AxiosResponse } from 'axios';

export const loginApi = async (data: IUserLogin): Promise<IUserLoginResponse> =>
  authHttp
    .post(`/vendor-auth/`, data, {
      errorHandler: false,
    })
    .then((response: AxiosResponse<IUserLoginResponse>) => {
      return response.data;
    });

export const refreshTokenApi = async (
  data: IUserRefreshBody
): Promise<IUserRefreshResponse> =>
  authHttp
    .post(`/refresh/`, data, {
      errorHandler: false,
    })
    .then((response: AxiosResponse<IUserRefreshResponse>) => {
      return response.data;
    });

export const forgotPasswordApi = async (
  data: IForgotPasswordDetails
): Promise<IForgotPasswordResponse> =>
  http
    .post(`/forgot-password/`, data, {
      errorHandler: true,
    })
    .then((response: AxiosResponse<IForgotPasswordResponse>) => {
      return response.data;
    });

export const resetPasswordApi = async (
  data: IResetPasswordDetails
): Promise<IResetPasswordResponse> =>
  http
    .post(`/reset-password/`, data, {
      errorHandler: true,
    })
    .then((response: AxiosResponse<IResetPasswordResponse>) => {
      return response.data;
    });

export const verifyUserTokenApi = async (
  data: IVerifyTokenDetails
): Promise<IVerifyTokenResponse> =>
  http
    .post(`/verify-token/`, data, {
      errorHandler: false,
    })
    .then((response: AxiosResponse<IVerifyTokenResponse>) => {
      return response.data;
    });
